import React from 'react';
import { Stack, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface ActionGroupBoneProps {
    /** Nombre d'actions */
    count?: number;
    /** Largeur des actions */
    actionWidth?: string;
    /** Hauteur des actions */
    actionHeight?: string;
    /** Direction d'affichage */
    direction?: 'row' | 'column';
    /** Espacement entre les éléments */
    spacing?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const ActionGroupBone: React.FunctionComponent<ActionGroupBoneProps> = function ({
    count = 2,
    actionWidth = '100px',
    actionHeight = '30px',
    direction = 'row',
    spacing = 1,
    sx = {},
}) {
    return (
        <Stack
            direction={direction}
            spacing={spacing}
            sx={sx}
        >
            {Array.from({ length: count }).map((_, index) => (
                <BoxBone
                    key={`action-${count}-${index + 1}`}
                    sx={{
                        width: actionWidth,
                        height: actionHeight,
                        borderRadius: '4px',
                    }}
                />
            ))}
        </Stack>
    );
};
